import { Divider, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { JobLogsDrawer } from '@/console/features/jobs/components/job-logs-drawer/job-logs-drawer';
import { PipelineStepStatusPopoverHeader } from '@/console/features/pipelines/components/pipeline-step-overview/pipeline-step-overview.styled';
import { TPipelineStepOverviewProps } from '@/console/features/pipelines/components/pipeline-step-overview/pipeline-step-overview.types';
import { PipelineStepStatusChip } from '@/console/features/pipelines/components/pipeline-step-status-chip/pipeline-step-status-chip';
import { TargetMenuItem } from '@/console/features/pipelines/components/target-menu-item/target-menu-item';
import { usePipelineStepType } from '@/console/features/pipelines/hooks/use-pipeline-step-type/use-pipeline-step-type';
import { PopoverController } from '@/shared/components/ui/popover/components/popover-controller/popover-controller';
import { ScrollFade } from '@/shared/components/ui/scroll-fade/scroll-fade';

export const PipelineStepOverview: React.FC<TPipelineStepOverviewProps> = ({
  step,
}) => {
  const { t } = useTranslation();
  const { getStepTypeIcon, getStepTypeLabel } = usePipelineStepType();

  const renderTargets = () => {
    if (step.__typename === 'PipelineExecutionStepResponseType') {
      return step.targets.map((item, index) => (
        <JobLogsDrawer
          key={index}
          jobId={item.jobId}
          trigger={<TargetMenuItem jobType={step.type} target={item} />}
        />
      ));
    }

    return step.targetConfiguration.map((item, index) => (
      <TargetMenuItem key={index} jobType={step.type} target={item} disabled />
    ));
  };

  return (
    <PopoverController
      trigger={<PipelineStepStatusChip step={step} />}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      {() => (
        <Stack gap="2px">
          <PipelineStepStatusPopoverHeader>
            <Typography variant="h7" color="textSecondary">
              {t('ui:step')}:
            </Typography>
            {getStepTypeIcon(step.type)}
            <Typography variant="p6">
              {step.name ?? getStepTypeLabel(step.type)}
            </Typography>
          </PipelineStepStatusPopoverHeader>
          <Divider />
          <ScrollFade gap="2px" maxHeight="16.875rem">
            {renderTargets()}
          </ScrollFade>
        </Stack>
      )}
    </PopoverController>
  );
};
